import { render, staticRenderFns } from "./LeadSourceRoi.vue?vue&type=template&id=0830dccb&scoped=true&"
import script from "./LeadSourceRoi.vue?vue&type=script&lang=js&"
export * from "./LeadSourceRoi.vue?vue&type=script&lang=js&"
import style0 from "./LeadSourceRoi.vue?vue&type=style&index=0&id=0830dccb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0830dccb",
  null
  
)

export default component.exports